import React, { useEffect, useState } from "react";
import {
  MAP_GLOBAL_STATES,
  SIDENAV_GLOBAL_STATE
} from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import { ButtonWrapper } from "commonComponents/SideNav/subSideNav/subSideNavStyled";
import { useTranslation } from "react-i18next";
import { getFeaturesList, isUserAdmin, isUserSupport } from "constant";
import { useSelector } from "react-redux";

export const CommonButton = ({
  labelText,
  displayText,
  children,
  changeSideNavData,
  disabled,
}) => {
  const { t } = useTranslation();
  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);
  const { sideDrawerActiveTabState, subNavDataState, sideNavMapState } = useHookstate(SIDENAV_GLOBAL_STATE);

  const { siteSettingsData, getUserRole } =
    useSelector((state) => state.commonReducers) || [];
  // this code only for ads module
  const [sideNavTab, setSideNavTab] = useState("");

  useEffect(() => {
    if (
      mapSideNavTabState.get() === "addCampaign" ||
      mapSideNavTabState.get() === "editCampaign"
    )
      setSideNavTab("Campaigns");
    else setSideNavTab(mapSideNavTabState.get());
  }, [mapSideNavTabState.get()]);

  useEffect(() => {
    if(localStorage.getItem("mapSideNavTabState") === "CPO" || 
      localStorage.getItem("mapSideNavTabState") === "Cars" ||
      localStorage.getItem("mapSideNavTabState") === "History" ||
      localStorage.getItem("mapSideNavTabState") === "Action Zones" ||
      localStorage.getItem("mapSideNavTabState") === "Site Setup" &&
    subNavDataState.get("MAP")){
      sideNavMapState.set(true)
    }
  },[mapSideNavTabState.get()])

  const isRealtimeEnabled =
    siteSettingsData?.Features?.includes(
      getFeaturesList()?.real_time_tracking
    );

  const isPrivilegedUser =
    isUserAdmin(getUserRole?.Role) ||
    isUserSupport(getUserRole?.Role);

  const canShowMessageSubtabs =
    isPrivilegedUser && !isRealtimeEnabled;

  return (
    <ButtonWrapper
      style={{
        background:
          sideDrawerActiveTabState.get() === 1 && mapSideNavTabState.get() === "CPO" || mapSideNavTabState.get() === "Action Zones" || mapSideNavTabState.get() === "Site Setup" && subNavDataState.get() === "MAP" ? (
            disabled
              ? "#808080"
              : sideNavTab &&
                sideNavTab === labelText &&
                sideNavTab !== "Site Setup"
                ? "var(--selected-btn-bg)"
                : labelText === "Site Setup"
                  ? "var(--admin-tab-bg)"
                  : ""
          )
            : (
              sideDrawerActiveTabState.get() === 3 &&
              canShowMessageSubtabs &&
              (
                labelText === "Inbox" ||
                labelText === "History" ||
                labelText === "Settings" ||
                labelText === "VDU" ||
                labelText === "Notifications" ||
                labelText === "Announcements"
              )
            )
              ? "var(--admin-tab-bg)"

              : (
                sideDrawerActiveTabState.get() === 3 &&
                (
                  labelText === "Admin" ||
                  labelText === "Support" ||
                  labelText === "Real Time Tracking"
                )
              )
                ? "var(--admin-tab-bg)"

                : disabled
                  ? "#808080"
                  : sideNavTab &&
                    sideNavTab === labelText &&
                    sideNavTab !== "Site Setup"
                    ? "var(--selected-btn-bg)"
                    : labelText === "Site Setup"
                      ? "var(--admin-tab-bg)"
                      : ""
        ,
        color: sideDrawerActiveTabState.get() === 1 && mapSideNavTabState.get() === "CPO" || mapSideNavTabState.get() === "Cars" || mapSideNavTabState.get() === "History" || mapSideNavTabState.get() === "Action Zones" || mapSideNavTabState.get() === "Site Setup" && subNavDataState.get() === "MAP" ? (
          mapSideNavTabState.get() && mapSideNavTabState.get() === labelText && sideNavMapState.get()
            ? "var(--theme-text)"
            : labelText === "Site Setup"
              ? "var(--text-secondary)"
              : "var(--text-secondary)"
        ) : (
          mapSideNavTabState.get() && mapSideNavTabState.get() === labelText
            ? "var(--theme-text)"
            : labelText === "Site Setup"
              ? "var(--text-secondary)"
              : "var(--text-secondary)"
        ),
        borderColor:
          mapSideNavTabState.get() && mapSideNavTabState.get() === labelText && sideNavMapState.get()
            ? "var(--theme-background)"
            : "var(--side-nav-btn-border-color)",
      }}
    >
      <button onClick={() => {
        changeSideNavData();
        sideNavMapState.get() && sideDrawerActiveTabState.get() === 1 ? sideNavMapState.set(false) : sideNavMapState.set(true)
      }} disabled={disabled}>
        {children}
        <p>{t(displayText)}</p>
      </button>
    </ButtonWrapper>
  );
};
